<div class="controls">
  <div class="time">
    <label class="mode-label">At</label>
    <div class="time-controls">
      <mat-select
        (selectionChange)="onTimeChanged()"
        [(value)]="selectedHour"
        class="hours"
        data-test="weekday-hour-selector"
      >
        <mat-select-trigger>{{ selectedHour.displayValue }}</mat-select-trigger>
        <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour.displayName }}</mat-option>
      </mat-select>

      <mat-select
        (selectionChange)="onTimeChanged()"
        [(value)]="selectedMinute"
        class="minutes"
        data-test="weekday-minute-selector"
      >
        <mat-select-trigger
          >{{ selectedMinute.displayValue }} {{ selectedHour.value < 12 ? 'am' : 'pm' }}</mat-select-trigger
        >
        <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute.displayName }}</mat-option>
      </mat-select>
    </div>
  </div>

  <div class="time-zone">
    <label class="mode-label visually-hidden">Time Zone</label>
    <mat-select
      (selectionChange)="onTimeChanged()"
      [(value)]="selectedTimeZone"
      data-test="weekday-time-zone-selector"
      class="time-zone-selector"
    >
      <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.value">{{ timeZone.displayName }}</mat-option>
    </mat-select>
  </div>
</div>
